import TextField from "@mui/material/TextField";
import React, { useCallback, memo } from "react";
import { NumericFormat } from "react-number-format";

export const NumberFormatCustom = React.forwardRef((props, ref) => {
  const { onChange, ...other } = props;

  const handleChange = useCallback(
    (value) => {
      if (onChange) {
        onChange({
          target: {
            name: props.name,
            value: value.value,
          },
        });
      }
    },
    [props.name, onChange]
  );

  return (
    <NumericFormat
      decimalScale={2}
      thousandSeparator=","
      {...other}
      decimalSeparator="."
      valueIsNumericString
      getInputRef={ref}
      onValueChange={handleChange}
    />
  );
});

export const formatNumber = (priceString, delimiter = ",") => {
  if (!priceString) {
    return 0;
  }

  return priceString
    .toString()
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${delimiter}`);
};

const Inputnumber = (props) => {
  const { InputProps, ...other } = props;

  return (
    <TextField
      {...other}
      InputProps={{
        ...InputProps,
        inputComponent: NumberFormatCustom,
      }}
    />
  );
};

export default memo(Inputnumber);
